import { cookieStorage, createConfig } from "@account-kit/core"
import { alchemy, gensynTestnet } from "@account-kit/infra"

export const config = createConfig({
	chain: gensynTestnet,
	transport: alchemy({ rpcUrl: `${import.meta.env.VITE_API_BASE_URL}/alc` }),
	policyId: "4c37387c-2a55-4edd-b188-b5c44eb71e96",
	storage: cookieStorage,
	enablePopupOauth: true,
})
